import { editor_children, bs_editor_children, app_editor_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const richTextChildren = JSON.parse(JSON.stringify(editor_children))
richTextChildren[0].thumbnail = "icon-portal-text1"
const cxEditor = {
  name: "cxEditor",
  desc: "文本样式",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  menus: {
    app: [
      {
        name: "文本",
        children: editor_children,
        enable: false,
        group: "baseElement",
        sort: 2
      },
      {
        name: "富文本",
        children: richTextChildren,
        group: "baseElement",
     // enable(params) {
        //   return params.admin
        // },
        sort: 5
      }
    ],
    bigScreen: [
      {
        name: "文本",
        children: bs_editor_children
      }
    ],
    portal: [
      {
        name: "文本",
        children: editor_children,
        enable: false,
        group: "baseElement",
        sort: 2
      },
      {
        name: "富文本",
        children: richTextChildren,
        group: "baseElement",
     // enable(params) {
        //   return params.admin
        // },
        sort: 5
      }
    ]
  },
  toolbars: [
    {
      name: "cxEditor",
      label: "文本",
      comp: {
        editorComponentData: () => import("./toolbars/editor-options-data.vue"),
        editorComponentSetting: () => import("./toolbars/editor-options-setting.vue"),
        editorComponentStyle: () => import("./toolbars/editor-options-style.vue")
      }
    }
  ]
}

export default cxEditor
